module.exports = __webpack_public_path__ + "static/img/3.f2b3238.png";


//////////////////
// WEBPACK FOOTER
// ./static/3.png
// module id = +oTD
// module chunks = 1